// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92bef15c","667":"e341de90","977":"e70ad62b"}[chunkId] + ".chunk.js";
};